export default __webpack_public_path__ + "static/media/pic2.7891100d.jpg";